/**
 * The home dashboard's tab search-param type + decoder, extracted into a
 * leaf module so the route's `validateSearch` (which stays in the eager
 * route-config chunk) doesn't drag the whole dashboard — charts included —
 * into the initial bundle.
 */
export type HomeTab = 'workspace' | 'mine'

/** Includes the one retired value that still has a redirect contract. */
export type HomeSearchTab = HomeTab | 'updates'

const HOME_TABS: readonly HomeSearchTab[] = ['workspace', 'mine', 'updates']

/**
 * Decodes the `tab` search param, returning `undefined` when it is absent or
 * unrecognised — deliberately, rather than defaulting to `'workspace'`.
 * `updates` remains recognised only so the route can redirect links from the
 * release where the inbox lived on Home to its standalone page.
 *
 * Defaulting here made `validateSearch` report a param the URL did not
 * carry, so TanStack Router rewrote every bare `/…/home` to the canonical
 * `?tab=workspace`. That put a 307 on the post-login landing — the most
 * requested URL in the app — costing a round trip on every sign-in, and
 * leaving it uncacheable at the edge (route rules don't run for redirects),
 * so it was the one app route with no cushion during a deploy.
 *
 * The route component applies the fallback instead.
 */
export const homeTabFromSearch = (raw: unknown): HomeSearchTab | undefined =>
  HOME_TABS.find((tab) => tab === raw)
